import React from 'react'

import { ProductListContextProvider } from './contexts'
import ProductList from './components/ProductList'

function ProductListContainer() {
  return (
    <ProductListContextProvider>
      <ProductList />
    </ProductListContextProvider>
  )
}

ProductListContainer.propTypes = {}

export default ProductListContainer
